(()=>{
  const stories=[...document.querySelectorAll('[data-package-story]')];
  if(!stories.length)return;

  const states=new WeakMap();
  const pageY=()=>window.scrollY||document.documentElement.scrollTop||0;
  const clamp=(value,min,max)=>Math.min(max,Math.max(min,value));

  stories.forEach(story=>{
    story.dataset.stage='0';
    states.set(story,{stage:0,travelled:0,lastY:pageY()});
  });

  const stageFor=(distance,viewport)=>{
    if(distance<viewport*.62)return 0;
    if(distance<viewport*1.30)return 1;
    if(distance<viewport*1.98)return 2;
    if(distance<viewport*2.62)return 3;
    return 4;
  };

  let ticking=false;
  const update=()=>{
    const currentY=pageY();
    const viewport=Math.max(1,window.innerHeight);

    stories.forEach(story=>{
      const state=states.get(story);
      const rect=story.getBoundingClientRect();
      const scene=story.querySelector('.pw-package-exploded__scene');
      const stickyTop=scene?parseFloat(getComputedStyle(scene).top)||0:0;
      const sceneHeight=scene?scene.getBoundingClientRect().height:viewport;
      const delta=clamp(currentY-state.lastY,-viewport*.45,viewport*.45);
      const active=rect.top<=stickyTop+1&&rect.bottom>=stickyTop+sceneHeight-1;

      if(active&&delta!==0){
        state.travelled=clamp(state.travelled+delta,0,viewport*2.78);
        const next=stageFor(state.travelled,viewport);
        if(next!==state.stage){
          state.stage=next;
          story.dataset.stage=String(next);
        }
      }

      state.lastY=currentY;
    });

    ticking=false;
  };

  const request=()=>{
    if(ticking)return;
    ticking=true;
    requestAnimationFrame(update);
  };

  addEventListener('scroll',request,{passive:true});
  addEventListener('resize',()=>{
    stories.forEach(story=>{states.get(story).lastY=pageY()});
  },{passive:true});
})();
